import React from 'react';

import type { CustomOfferFormValues } from '@/typings/formValues';
import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';

import Grid from '@mui/material/Grid';

import DateWidget from '~/components/Common/Elements/DateWidget';

import { VccCreatedDisableFieldHelperText } from '../../Components/VccCreatedDisableFieldHelperText';

type Props = {
  control: Control<CustomOfferFormValues>;
  disableVendorVccFieldsOnceVccIsCreated: boolean;
  isSubmitting: boolean;
};

export default function CruisePostPurchaseCoreDetails({
  control,
  disableVendorVccFieldsOnceVccIsCreated,
  isSubmitting,
}: Props) {
  return (
    <Grid mt={2} columns={4} spacing={2} container>
      <Grid size={{ xs: 4, md: 1 }}>
        <Controller
          name="item.start_date"
          control={control}
          render={({ field: { ref: _, ...field }, fieldState: { error } }) => (
            <>
              <DateWidget
                {...field}
                label="Departure date"
                slotProps={{ textField: { helperText: error?.message, error: !!error, required: true } }}
                disabled={isSubmitting || disableVendorVccFieldsOnceVccIsCreated}
                fullWidth
                data-testid="start-date"
              />
              {disableVendorVccFieldsOnceVccIsCreated && <VccCreatedDisableFieldHelperText />}
            </>
          )}
        />
      </Grid>
    </Grid>
  );
}
